import { render } from "./Dialog.vue?vue&type=template&id=02d53448"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=02d53448&lang=scss"
script.render = render

export default script